import { createBrowserRouter } from "react-router-dom";

import { DefaultLayout } from "../layout";
import IndexPage from "../pages";

export const router = createBrowserRouter(
  [
    {
      path: "/",
      element: <DefaultLayout />,
      children: [{ index: true, element: <IndexPage /> }],
    },
  ],
  { basename: "/invitation" }
);
